import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Alert } from "@material-ui/lab";
import moment from "moment";
import Swal from "sweetalert2";
import StudentInfoForm from "./StudentInfoForm";

class UpdateStudent extends Component {
  
  constructor(props) {
    super(props);
    this.submitFunction = this.submitFunction.bind(this);
    
    this.state = {
      apiError: false
    };
  }

  async componentDidMount() {
    const url_array = document.location.href.split("/");
    const id = Number(url_array[url_array.length - 1]);
    this.setState({
      lcf_id_original: id
    });
  }

  render() {
    const heading = (
      <center>
        <h1 style={{ width: "50%", marginTop: "2%" }}>
          Update Student Information
        </h1>
      </center>);


    return (<>
      {heading}
      {this.state.apiError === true && (
        <Alert className="error" style={{}} severity="error">
          An error occurred while contacting the server.
          Please try again later.
        </Alert>
      )}
      <StudentInfoForm
        submitFunction={this.submitFunction}
        lcf_id_original={this.state.lcf_id_original}
        newStudent={false}
      />
    </>);
  }
  
  async submitFunction(stuInfo) {

    const confirm = await Swal.fire({
      title: "Please confirm details below",
      html: `1. First Name: ${stuInfo.first_name} </br>
      2. Last Name: ${stuInfo.last_name} </br>
      3. Student Grade: ${stuInfo.grade} </br>
      4. LCF Start Date: ${stuInfo.lcf_start_date} </br>
      5. Student Year: ${stuInfo.grad_year} </br>
      6. School ${stuInfo.school_attend} </br>
      7. ID Number ${stuInfo.lcf_id} </br>
      8. Email Address: ${stuInfo.student_email} </br>
      9. PIF Amount: ${stuInfo.pif_amount} </br>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#5cb85c",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm my entry",
    });
    if (!confirm.value) {
      return;
    }

    const payload = {
      first_name: stuInfo.first_name,
      last_name: stuInfo.last_name,
      grade: stuInfo.grade,
      grad_year: stuInfo.grad_year,
      school_attend: stuInfo.school_attend,
      lcf_id: stuInfo.lcf_id,
      lcf_start_date: stuInfo.lcf_start_date,
      student_email: stuInfo.student_email,
      pif_amount: stuInfo.pif_amount,
    };

    axios.put(`/api/student/updatestudent/${this.state.lcf_id_original}`
      , payload)
      .then(() => {
        Swal.fire("Success!", "The student's info has been updated."
          , "success");
        this.props.history.push("/home");
      })
      .catch((error) => {
        console.log(error);
        this.setState({apiError:true});
        setTimeout(() => {
          this.setState({apiError: false})
        }, 5000);
      });
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(UpdateStudent);
